import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ClientAuthService, UsersService } from 'src/app/api/identity/services';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { Subscription, interval } from 'rxjs';
import {
  OtpValidationRequest,
  ResendOtpRequest,
  UserProfileDto,
} from 'src/app/api/identity/models';
import { RedirectService } from 'src/app/shared/services/redirect-service';
import {
  BrandingService,
  BrandProfile,
} from 'src/app/shared/branding/branding.service';
@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
})
export class VerificationComponent implements OnInit {
  otp = '';
  isVerifying = false;
  verificationMessage = '';
  username = '';
  loggedInUser: UserProfileDto = {};
  readonly brand: BrandProfile;

  resendTimer = 30;
  isResendDisabled = false;
  private timerSubscription: Subscription | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private authService: ClientAuthService,
    private localStorageService: LocalStorageService,
    private redirectService: RedirectService,
    private userService: UsersService,
    branding: BrandingService
  ) {
    this.brand = branding.brand;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.username = params['username'] || '';
    });
  }

  onOtpChange(otp: string) {
    this.otp = otp;
  }

  fetchLoggedInUser(isPasswordReset: boolean) {
    this.userService.getLoggedInUserDetails().subscribe({
      next: user => {
        if (user?.data) {
          this.loggedInUser = user?.data[0] || {};

          this.redirectService.setPermissions(
            this.loggedInUser.Privileges || []
          );
          this.isVerifying = false;

          if (isPasswordReset) {
            this.router.navigateByUrl('/welcome');
          } else if (!isPasswordReset) {
            this.router.navigateByUrl('/reset-password');
          }
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }

  verifyOtp() {
    this.isVerifying = true;
    this.verificationMessage = '';

    const otpRequest: OtpValidationRequest = {
      otp: this.otp,
      username: this.username,
    };

    this.authService.clientTwoFactorLogin({ body: otpRequest }).subscribe({
      next: response => {
        const token = response.data
          ? (response.data[0].accessToken as string)
          : '';
        const refresh = response.data
          ? (response.data[0].refreshToken as string)
          : '';
        this.localStorageService.setItem('invoiceToken', token);
        this.localStorageService.setItem('invoiceRefreshToken', refresh);

        const decodedToken = this.redirectService.decodeToken(token);
        this.toastr.success('OTP verified successfully!');
        if (decodedToken) {
          this.localStorageService.setItem('clienyId', decodedToken.sub);
          this.fetchLoggedInUser(response?.data?.[0]?.isPasswordReset || false);
        }
      },
      error: error => {
        this.isVerifying = false;
        this.verificationMessage = 'Invalid OTP. Please try again.';
        this.toastr.error(error.error.message);
      },
    });
  }

  resendOtp() {
    const resendRequest: ResendOtpRequest = {
      username: this.username,
    };

    this.authService.clientResendOtp({ body: resendRequest }).subscribe({
      next: response => {
        this.toastr.success(response.message);
        this.startResendTimer();
      },
      error: error => {
        this.toastr.error(error.error.message);
      },
    });
  }

  startResendTimer() {
    this.isResendDisabled = true;
    this.resendTimer = 30;

    this.timerSubscription = interval(1000).subscribe(() => {
      this.resendTimer--;
      if (this.resendTimer <= 0) {
        this.isResendDisabled = false;
        this.resendTimer = 0;
        this.timerSubscription?.unsubscribe();
      }
    });
  }

  ngOnDestroy() {
    this.timerSubscription?.unsubscribe();
  }
}
